import { Box } from "@mui/material";
import { cloudyIndigoColor, cyanBlue, darkBlueShadeColor, lightWhiteFadeColor, white, yellowishWhiteColor, yellowishWhiteLowShadeColor } from "../../config/ColorObj";

// Row styles
const getRowStyle = (index) => ({
    background: index % 2 === 0 ? white : yellowishWhiteLowShadeColor,
    borderBottom: "1px solid #e9ecef",
    transition: "background 0.2s ease",
});

// Cell base
const baseCell = {
    padding: "14px 12px",
    color: darkBlueShadeColor,
};

// Cell variants
const centerCell = {
    ...baseCell,
    textAlign: "center",
};

const leftCell = {
    ...baseCell,
    textAlign: "left",
};

const rightCell = {
    ...baseCell,
    textAlign: "right",
};

// Typography variants
const mutedText = {
    color: cloudyIndigoColor,
};

const boldText = {
    fontWeight: 600,
};

const strongText = {
    fontWeight: 700,
};

const baseHeaderStyle = {
    padding: "14px 12px",
    fontWeight: 600,
    fontSize: "14px",
};

const headerStyleCenter = {
    ...baseHeaderStyle,
    textAlign: "center",
    width: "8%",
    position: "sticky",
    top: 0,
    zIndex: 3,
    background: cyanBlue,
    color: white,
};

const headerStyleLeft = {
    ...baseHeaderStyle,
    textAlign: "left",
    width: "30%",
    color: white,
    position: "sticky",
    top: 0,
    zIndex: 3,
    background: cyanBlue,
};

const headerStyleRight = {
    ...baseHeaderStyle,
    textAlign: "right",
    width: "15%",
    color: white,
    position: "sticky",
    top: 0,
    zIndex: 3,
    background: cyanBlue,
};

const OutletProductTable = ({ items, isSelected }) => {
    return (
        <Box
            sx={{
                padding: "20px",
                background: isSelected ?
                    yellowishWhiteColor : yellowishWhiteLowShadeColor,
                animation: "slideDown 0.3s ease-out",
                "@keyframes slideDown": {
                    from: {
                        opacity: 0,
                        transform: "translateY(-10px)",
                    },
                    to: {
                        opacity: 1,
                        transform: "translateY(0)",
                    },
                },
            }}
        >
            <Box
                sx={{
                    background: white,
                    borderRadius: "12px",
                    overflow: "hidden",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                }}
            >
                <div
                    style={{
                        maxHeight: "250px",
                        overflowY: "auto",
                        border: "1px solid #e5e7eb",
                        borderRadius: "8px",
                        position: "relative",
                    }}
                >
                    <table
                        style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            fontSize: "14px",
                        }}
                    >
                        <thead>
                            <tr
                                style={{
                                    background: cyanBlue,
                                    color: white,
                                }}
                            >
                                <th style={{ ...headerStyleCenter }}>Sr</th>
                                <th style={{ ...headerStyleLeft }}>Product</th>
                                <th style={{ ...headerStyleCenter }}>HSN</th>
                                <th style={{ ...headerStyleRight }}>Qty</th>
                                <th style={{ ...headerStyleRight }}>Taxable</th>
                                <th style={{ ...headerStyleRight }}>Tax</th>
                                <th style={{ ...headerStyleRight }}>Total</th>
                            </tr>
                        </thead>

                        <tbody>
                            {items?.map((productData, productIndex) => (
                                <tr
                                    key={productIndex}
                                    style={getRowStyle(productIndex)}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.background = lightWhiteFadeColor;
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.background =
                                            productIndex % 2 === 0 ? white : yellowishWhiteLowShadeColor;
                                    }}
                                >
                                    <td style={{ ...centerCell, ...mutedText, ...boldText }}>
                                        {productIndex + 1}
                                    </td>

                                    <td style={{ ...leftCell, fontWeight: 500 }}>
                                        {productData.itemName}
                                    </td>

                                    <td style={{ ...centerCell, ...mutedText, fontFamily: "monospace" }}>
                                        {productData.hsnCode}
                                    </td>

                                    <td style={{ ...rightCell, ...boldText }}>
                                        {productData.qty}
                                    </td>

                                    <td style={rightCell}>
                                        ₹{productData.taxableAmt}
                                    </td>

                                    <td style={rightCell}>
                                        ₹{productData.taxAmt}
                                    </td>

                                    <td style={{ ...rightCell, ...strongText }}>
                                        ₹{productData.totalAmt}
                                    </td>
                                </tr>
                            ))}
                        </tbody>

                    </table>
                </div>
            </Box>
        </Box>
    );
};

export default OutletProductTable;